import { useState } from "react";
import { Controller } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { Button as AButton } from "@material-ui/core";
import { useGlobalStyles } from "./globalStyles";
import { commonStrings } from "./StringBundle";

const AttachmentFieldInput = ({
  name,
  control,
  label = "Attachment",
  required = false,
  disabled = false,
  accept,
  acceptErrorMsg = "",
  sx = {},
}) => {
  const labelWithAsterisk = required ? `${label} *` : label;
  const classes = useGlobalStyles();
  const [typeError, setTypeError] = useState("");

  const allowedExtensions = accept
    ? accept.split(",").map((s) => s.trim().replace(/^\./, "").toLowerCase())
    : [];

  const readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        resolve(e.target.result); // base64 or text
      };

      reader.onerror = (e) => {
        reject(e);
      };

      // You can use .readAsText(file) if you want raw text (e.g., .txt files)
      reader.readAsDataURL(file); // base64 encoding
    });
  };

  async function onFileChange(e, field) {
    const file = e.target.files?.[0];
    if (!file) return;

    if (allowedExtensions.length > 0) {
      const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
      if (!allowedExtensions.includes(ext)) {
        setTypeError(acceptErrorMsg || commonStrings.invalidAcceptType.replace("{formats}", allowedExtensions.join(", ").toUpperCase()));
        field.onChange(null);
        e.target.value = "";
        return;
      }
    }

    setTypeError("");
      try {
        const content = await readFileContent(file);
        field.onChange({
          file, 
          content,
        });
      } catch (err) {
        console.error("File read error:", err);
        field.onChange(null);
      }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, ...sx }}>
          <AButton
              label=""
              variant="contained"
              component="label"
              className={classes.button}
              disabled={disabled}
            >
            {labelWithAsterisk}<span class="material-icons">attach_file</span>
            <input
              type="file"
              hidden
              accept={accept}
              disabled={disabled}
              onChange={async (e) => onFileChange(e, field)}
            />
          </AButton>
          {field.value?.file?.name && (
            <Typography variant="body2">
              {field.value.file.name}
            </Typography>
          )}
          {typeError && (
            <Typography variant="caption" color="error">
              {typeError}
            </Typography>
          )}
          {!typeError && error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};

export default AttachmentFieldInput;